import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, Fields, reduxForm, change } from 'redux-form';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import FormsCheckbox from '../checkbox';
import VoucherFields from '../voucherFields';
import { requiredValidation } from '../../validations';
import * as ggFormSelectors from '../../selectors';
import styles from './index.module.scss';

@reduxForm({
    getFormState: (state) => ggFormSelectors.reduxForm(state),
    form: 'voucherForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
    /*
     * when we switch to list of payments from creating list
     * we lose state of voucher due to incorrect sequence redux form hooks
     * https://github.com/redux-form/redux-form/issues/3435
     * was fixed in v7 version
     * */
    destroyOnUnmount: false,
    onSubmitSuccess: (res, dispatch) => {
        dispatch(change('voucherForm', 'showVoucher', true));
    },
    validate: (values) => {
        const errors = {};

        errors.voucher = {
            name: requiredValidation(values.voucher && values.voucher.name),
        };

        return errors;
    },
})
class VoucherForm extends Component {
    render() {
        const {
            submitVoucher,
            resetVoucher,
            currencySymbol,
            orderHasPromotion,
            handleSubmit,
            submitting,
            initialValues,
            voucherFormValues,
            error,
        } = this.props;
        const isDisabled = !!(
            initialValues.voucher &&
            initialValues.voucher.discount &&
            initialValues.voucher.name
        );

        return (
            <form
                onSubmit={handleSubmit(isDisabled ? resetVoucher : submitVoucher)}
                className={styles.voucherForm}
            >
                <div className={styles.voucherForm__wrap}>
                    <Field
                        name="showVoucher"
                        label="REDEEM_VOUCHER"
                        component={FormsCheckbox}
                        disabled={orderHasPromotion}
                    />
                    {orderHasPromotion && (
                        <Translator
                            tk="PROMOTION_VOUCHER_NOT_APPLY"
                            className={styles.voucherForm__promotionNote}
                        />
                    )}
                    {voucherFormValues && voucherFormValues.showVoucher && (
                        <Fields
                            names={['voucher.name', 'voucher.discount']}
                            globalError={error}
                            label="USE_VOUCHER"
                            loading={submitting}
                            disabled={isDisabled}
                            component={VoucherFields}
                            currencySymbol={currencySymbol}
                        />
                    )}
                </div>
            </form>
        );
    }
}

export default VoucherForm;

VoucherForm.propTypes = {
    voucherFormValues: PropTypes.shape({
        showVoucher: PropTypes.bool,
    }),
    submitVoucher: PropTypes.func.isRequired,
    resetVoucher: PropTypes.func.isRequired,
    currencySymbol: PropTypes.string.isRequired,
    orderHasPromotion: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    initialValues: PropTypes.shape({
        voucher: PropTypes.object,
    }),
    error: PropTypes.shape({}),
};

VoucherForm.defaultProps = {
    voucherFormValues: {},
    submitting: undefined,
    initialValues: {},
    error: {},
};
